// extracted by mini-css-extract-plugin
export default {"field":"question_field__xVsO8","dayTime":"question_dayTime__v6ufn"};